import { useToast } from '../composables/useToast'

type ToastType = 'success' | 'error' | 'warning' | 'info'

const toast = useToast()

const toMessage = (message: unknown) => {
  if (message == null) return ''
  if (typeof message === 'string') return message
  if (message instanceof Error) return message.message
  try {
    return JSON.stringify(message)
  } catch {
    return String(message)
  }
}

export const notify = (message: unknown, type: ToastType = 'info', duration?: number) => {
  const safeMessage = toMessage(message)
  if (!safeMessage) return
  toast[type](safeMessage, duration)
}

export const notifySuccess = (message: unknown, duration?: number) => notify(message, 'success', duration)
export const notifyError = (message: unknown, duration?: number) => notify(message, 'error', duration)
export const notifyWarning = (message: unknown, duration?: number) => notify(message, 'warning', duration)
export const notifyInfo = (message: unknown, duration?: number) => notify(message, 'info', duration)

